<template>
    <div class="fixed left-1/2 bottom-10 w-[90vw] md:w-[60vw] flex items-center gap-x-6 p-4 md:p-6 bg-white rounded-lg -translate-x-1/2 shadow-lg z-50">
        <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" class="hidden md:block" />
        <div v-if="countryCode === 'GB'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to the United Kingdom!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Alright mate welcome to Blighty</p>
            <p class="text-sm md:text-base">Better make sure you have those pounds ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'FR'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to France!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Bonjour! You have arrived in France, home of the pain au chocolat!</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'BE'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Belgium!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Blistering barnacles! You have arrived in Belgium, home of the Tintin!</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'ES'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Spain!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">¡Hola! You have arrived in Spain. Un cervesa por favor!</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'PT'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Portugal!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Olá! You have arrived in Portugal, home of the pastel de nata!</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'GI'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Gibraltar!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">You have arrived in Gibraltar, a strange place that is both British and Spanish.  Watch out for the monkeys!</p>
            <p class="text-sm md:text-base">Better make sure you have those pounds ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'NL'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to the Netherlands!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Hallo! You have arrived in the Netherlands, home of wacky backy hehe!</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'DK'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Denmark!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Hej! You have arrived in Denmark, the home of the LEGO (not LEGOs)!</p>
            <p class="text-sm md:text-base">Better make sure you have those kroner ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'DE'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Germany!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Hallo! You have arrived in Germany, the home of the Autobahn!</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'IT'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Italy!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Mama Mia! You have arrived in Italy.  My best mate is Italian fyi</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
        <div v-if="countryCode === 'CH'">
            <div class="flex items-center gap-x-2 mb-2">
                <img :src="`${BaseUrl}img/flags/${countryCode.toLowerCase()}.webp`" alt="Flag" width="40" class="md:hidden" />
                <h2 class="text-xl md:text-2xl font-bold">Welcome to Switzerland!</h2>
            </div>
            <p class="text-sm md:text-base mb-2">Hello / Bonjour / Hallo, you have arrived in Switzerland.  Home to Toblerone and Roger Federer</p>
            <p class="text-sm md:text-base">Better make sure you have those euros ready, if you don't have any you <strong>can head to a bank</strong>.  <span v-if="timezoneOffsetString">Oh and in case you hadn't noticed you're now <strong>{{ timezoneOffsetString }}</strong>.</span></p>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    countryCode: String,
    timezoneOffset: Number
});

const BaseUrl = ref(baseUrl);

const timezoneOffsetString = computed(() => {
    const hours = Math.floor(props.timezoneOffset / 3600);
    
    if (hours >= 0) {
        if(hours > 1) {
            return `${hours} hours ahead`;
        }
        return 'an hour ahead';
    } else if (hours < 0) {
        if(hours < -1) {
            return `${hours} hours behind`;
        }
        return 'an hour behind';
    } else {
        return null;
    }
});
</script>